import { render, staticRenderFns } from "./PartidaequipamientoForm.vue?vue&type=template&id=1d142ddd"
import script from "./PartidaequipamientoForm.vue?vue&type=script&lang=js"
export * from "./PartidaequipamientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports